const STEPS = {
  PROPERTY: 'property',
  UNIT_NUMBER: 'unitNumber',
  CONGRATULATE: 'congratulate',
  INTERMITTENT: 'intermittent',
};

const { PROPERTY, UNIT_NUMBER, CONGRATULATE, INTERMITTENT } = STEPS;

const STEPPER = {
  [PROPERTY]: { submitText: 'Next', cancelText: 'Cancel' },
  [UNIT_NUMBER]: { submitText: 'Convert', cancelText: 'Back' },
  [CONGRATULATE]: { submitText: 'Done', cancelText: '' },
  [INTERMITTENT]: { submitText: 'Loading...', cancelText: '' },
};

export { STEPS, STEPPER };
